// extracted by mini-css-extract-plugin
module.exports = {"section":"Section_section__GbnZA","children":"Section_children__SCk5D"};